import { useRegisterSW } from 'virtual:pwa-register/react'

import { Button } from '@/shared/components/ui/button'

export default function ReloadPrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW()

  if (!needRefresh) {
    return null
  }

  return (
    <div
      className="fixed bottom-4 left-4 right-4 z-50 flex items-center justify-between gap-4 rounded-lg bg-primary p-4 text-primary-foreground shadow-lg"
      data-testid="reload-prompt"
    >
      <span className="text-sm font-medium">A new version is available.</span>
      <Button onClick={() => updateServiceWorker(true)} size="sm" variant="secondary">
        Reload
      </Button>
    </div>
  )
}
